// extracted by mini-css-extract-plugin
module.exports = {"container":"_2Ijjg","icon":"_2zojN"};